document.addEventListener('alpine:init', () => {
  Alpine.store('header', {
    h: 0,
    ty: 0,
    isMobileMenuVisible: false,
    mobileMenuSecondLevelVisible: false,
    mobileMenuSecondLevelIndex: null,

    openMobileMenu() {
      this.isMobileMenuVisible = true;
      this.mobileMenuSecondLevelVisible = false;
    },

    closeMobileMenu() {
      this.isMobileMenuVisible = false;
    },

    toggleMobileMenu() {
      if (this.isMobileMenuVisible) {
        this.closeMobileMenu();
      } else {
        this.openMobileMenu();
      }
    },

    openMobileMenuSecondLevel(index) {
      this.mobileMenuSecondLevelVisible = true;
      this.mobileMenuSecondLevelIndex = index;
    },

    closeMobileMenuSecondLevel() {
      this.mobileMenuSecondLevelVisible = false;
    },
  });

  Alpine.data('headerNew', () => ({
    currentSubmenu: -1,
    prevY: 0,

    init() {
      this.$nextTick(() => {
        this.onScroll();
        window.addEventListener('scroll', () => this.onScroll());
      });
    },

    toggle(i) {
      this.currentSubmenu = this.currentSubmenu === i ? -1 : i;
    },

    onScroll() {
      const y = window.scrollY;
      this.$store.header.h = this.$root.offsetHeight;
      this.$store.header.ty = Math.max(0, Math.min(this.$store.header.h, this.$store.header.ty + y - this.prevY));
      this.prevY = y;
    },
  }));
});